import React from 'react';
import get from 'lodash.get';

import SwapDeviceObject from './SwapDeviceObject';

import Card from './Card';

const CustomerOwned = ({
  device,
  hasNoLeasedDevice,
}) => {
  const message = get(device, 'programs[0].messages[0]');

  return (
    <div className="swap-option">
      <div className="card-group">
        <div className="card-group__item">
          <Card>
            <p className="heading3">Your Personal Device</p>
          </Card>
        </div>
        <div className="card-group__item">
          <Card className="card--secondary">
            <div className="ma-grid mb18">
              <div className="ma-grid__col ma-grid__col--1of2">
                <SwapDeviceObject device={device} title="What you have" />
              </div>
              <div className="ma-grid__col ma-grid__col--1of2 d-flex align-items-center">
                <ul className="mb0">
                  <li>
                    {'You can rent an Xfinity Wireless Gateway. '}
                    {!hasNoLeasedDevice && (
                      <a
                        href="https://www.xfinity.com/learn/internet-service/modems-and-routers"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Learn More
                      </a>
                    )}
                  </li>
                  <li>
                    {`Prefer to use your own device? Check out a list of Xfinity
                    supported modems. `}
                    {!hasNoLeasedDevice && (
                      <a
                        href="https://mydeviceinfo.xfinity.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Compatible Equipment
                      </a>
                    )}
                  </li>
                </ul>
              </div>
            </div>

            {message && (
              <div className="hgroup">
                <h5>Why do I need to update this device?</h5>
                <p>{message}</p>
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CustomerOwned;
